import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Store } from "react-notifications-component";
import { OtpInput } from "reactjs-otp-input";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

function UserNumberVerify({ RendomTokenfetch, userNumber }) {
  const navigate = useNavigate();
  const notification = {
    // message: "teodosii@react-notifications-component",
    insert: "top",
    container: "bottom-center",
    animationIn: ["animate__animated", "animate__fadeIn"],
    animationOut: ["animate__animated", "animate__fadeOut"],
    dismiss: {
      duration: 2000,
      showIcon: true,
      onScreen: true,
    },
  };

  // console.log(userNumber);

  const getMaskedNumber = (num) => {
    const strNum = num.toString();
    return strNum.slice(0, -4).replace(/\d/g, "*") + strNum.slice(-4);
  };

  const [SentOTP, setSentOTP] = useState("");
  const handleOTP = (SentOTP) => setSentOTP(SentOTP);

  const handleVarifyNumberSubmit = (event) => {
    event.preventDefault();
    let fdata = new FormData();
    fdata.append("number", userNumber);
    fdata.append("otp", SentOTP);
    axios
      .post(`${WebsiteAPIurl}registerotpverify`, fdata, {
        headers: {
          Authorization: RendomTokenfetch,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        // console.log(response.data);
        if (SentOTP && userNumber) {
          if (response.data.Status === "1") {
            Store.addNotification({
              ...notification,
              title: response.data.message,
              type: "success",
              onRemoval: () => {
                navigate("/login");
                // window.location.reload();
              },
            });
            // window.localStorage.setItem("varifyuser", "1");

            // window.localStorage.setItem(
            //   "userid",
            //   response.data.userdata.userid
            // );
          }
          if (response.data.Status === "0") {
            Store.addNotification({
              ...notification,
              title: response.data.message,
              type: "danger",
            });
          }
        } else {
          // setError(LoginAPIvalidation(response.data.form_validation));
        }
      });
    // .catch((error) => {
    //   alert(error);
    // });
  };

  return (
    <>
      <h3>Verify Number</h3>
      <form onSubmit={handleVarifyNumberSubmit}>
        <div className="text-center mb-3">
          {" "}
          <span>A code has been sent to</span>{" "}
          <small id="maskedNumber">{getMaskedNumber(userNumber)}</small>{" "}
        </div>
        <div className="form-group">
          <label>
            Enter OTP<span className="text-danger">*</span>
          </label>
          {/* <div className="otpganratebox">
                    <input
                      className="form-controll"
                      type="text"
                      name="otp"
                      value={SentOTP || ""}
                      onChange={handleChangePWD}
                    />
                  </div> */}
          <OtpInput
            value={SentOTP || ""}
            onChange={handleOTP}
            numInputs={6}
            separator={<span>-</span>}
            inputStyle={{ width: "4rem", fontSize: "22px" }}
          />
          {/* {error.otp && <span className="text-danger">* {error.otp}</span>} */}
        </div>

        <div className="form-group">
          <button
            className="theme-btn btn-style-one"
            type="submit"
            name="submit"
          >
            Submit
          </button>
        </div>
      </form>
    </>
  );
}

export default UserNumberVerify;
